import { MarkdownContent } from "~components";
import {
  translate as t,
  type DocWorkflowStepData,
  type DocWorkflowStepQuestionDatum,
  type KeyWithEmptyFnParam,
} from "~utils";

import { type TaskOnChange } from "../hooks/use-task";
import { Answer } from "./answers/answer";

export type QuestionType = DocWorkflowStepData["questions"][number];

export type QuestionProps = QuestionType & {
  state?: DocWorkflowStepQuestionDatum;
  onChange: TaskOnChange;
};

export function Question(props: QuestionProps) {
  const { text, desc, answerPosition, answerType, state, attribute, onChange } = props;
  const description = desc?.text;

  return (
    <div
      css={{
        backgroundColor: "var(--swing-white200)",
        display: "flex",
        flexDirection: "column",
        gap: "var(--spacing-lg)",
        color: "black",
      }}
    >
      {answerPosition === "TOP" && (
        <Answer
          answerType={answerType}
          value={state?.answerValue ?? undefined}
          onChange={(value) => onChange(attribute, value)}
          isReadOnly={state?.isReadOnly}
        />
      )}

      <div css={{ margin: 0, fontWeight: "var(--swing-font-semibold)" }}>
        <MarkdownContent body={t(text as unknown as KeyWithEmptyFnParam)} />
      </div>

      {description && (
        <div css={{ margin: 0 }}>
          <MarkdownContent body={t(description as unknown as KeyWithEmptyFnParam)} />
        </div>
      )}

      {answerPosition === "BOTTOM" && (
        <Answer
          answerType={answerType}
          value={state?.answerValue ?? undefined}
          onChange={(value) => onChange(attribute, value)}
          isReadOnly={state?.isReadOnly}
        />
      )}
    </div>
  );
}
